import {
  Tabs,
  WhiteSpace,
  List,
  Button,
  Modal,
  Checkbox,
  InputItem,
  Picker,
  Toast,
  Radio,
} from "antd-mobile-v2";
import "./index.less";
import React, { Component } from "react";
import { createForm } from "rc-form";
import VerctionPhone from "./verificationPhone";
import VerctionUser from "./verificationUser";
import ConfimPaswed from "./confimPasswed";
class EditPasWed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 60,
      flagCode: true,
      value: "0",
      value2: 0,
      isSubMit: false,
    };
  }
  componentDidMount() {
    console.log(this.props);
  }
  onChange = (value) => {
    this.setState({
      value,
    });
  };
  onChange2 = (value) => {
    this.setState({
      value2: value,
    });
  };
  // 按钮的下一步操作
  submitData = () => {
    this.setState({
      isSubMit: true,
    });
  };
  render() {
    const { value, isSubMit } = this.state;
    return (
      <div className="wrap-edit">
        {isSubMit ? (
          <ConfimPaswed props={this.props} />
        ) : (
          <div>
            <div className="radio-header">
              <Radio
                className="my-radio"
                checked={value === "0"}
                onChange={() => this.onChange("0")}
              >
                密保验证
              </Radio>
              <Radio
                className="my-radio"
                checked={value === "1"}
                onChange={() => this.onChange("1")}
              >
                手机验证
              </Radio>
            </div>
            <div>
              {value == "0" ? (
                <VerctionUser submitData={this.submitData} />
              ) : (
                <VerctionPhone submitData={this.submitData} />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default createForm()(EditPasWed);
